import {useInViewEffect} from '@aboutyou/ui-components';
import {
  ContentBlockPromotionTrackingInterface,
  useContentBlockPromotionTracking,
} from './useContentBlockPromotionTracking';

export const useContentBlockPromotionTrackingImpression = <
  T extends HTMLElement,
>(
  props: Omit<ContentBlockPromotionTrackingInterface, 'actionType'>,
) => {
  const contentBlockPromotionTracking = useContentBlockPromotionTracking();

  const {ref} = useInViewEffect<T>(
    (isInView: boolean) => {
      if (isInView) {
        contentBlockPromotionTracking({
          ...props,
          actionType: 'impression',
        });
      }
    },
    {
      threshold: 0.5,
      triggerOnce: true,
    },
  );

  return {
    elementRef: ref,
  };
};
